module.exports = __webpack_public_path__ + "img/recurring.0ee277f2.svg";